import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { addLocaleToHref } from 'lib/utils/helpers';
import { formatPriceByStoreLocale } from 'lib/shopify';
import styles from './bundleVariations.module.scss';
import SiteLink from '../../../shared/sitelink';

const BundleVariations = ({ locale, productBundleData, resources, localeHasWebshop }) => {
  const router = useRouter();
  const { bundleVariations } = productBundleData;
  const { chooseVariant } = resources.productpage;

  const allSortedBundleVariations = useMemo(() => {
    const parseBundleVariation = variation => {
      const sizes = [];
      let totalPrice = 0;
      let totalSize = 0;
      const products = variation.productsCollection.items;
      products.forEach(product => {
        const { size: productSize, shopifyData } = product;
        if (productSize) sizes.push(productSize);
        totalPrice += parseFloat(shopifyData?.variants?.[0]?.price);
        totalSize += parseInt(productSize.replace('ml', '') || 0, 10);
      });

      return {
        size: sizes.join(' + '),
        price: formatPriceByStoreLocale({ locale, price: parseFloat(totalPrice).toFixed(2) }),
        slug: variation.slug,
        totalSize,
      };
    };

    return [
      bundleVariations.length
        ? { ...parseBundleVariation(productBundleData), isCurrentProduct: true }
        : null,
      ...bundleVariations.map(v => parseBundleVariation(v)),
    ].sort((a, b) => a.totalSize - b.totalSize);
  }, [bundleVariations, locale, productBundleData]);

  return allSortedBundleVariations?.length > 1 ? (
    <>
      <h3 className={styles.productVariationsTitle}>{chooseVariant.text}</h3>
      <div className={styles.productVariations}>
        {allSortedBundleVariations.map(variant => {
          if (variant.isCurrentProduct) {
            return (
              <p key={variant.slug} className={styles.currentProductVariant}>
                <span className={styles.variantSize}>{variant.size}</span>
                {localeHasWebshop && <span className={styles.variantPrice}>{variant.price}</span>}
              </p>
            );
          }
          return (
            <SiteLink
              key={variant.slug}
              className={styles.variantLink}
              href={addLocaleToHref(variant.slug, locale, router)}
            >
              <span className={styles.variantSize}>{variant.size}</span>
              {localeHasWebshop && <span className={styles.variantPrice}>{variant.price}</span>}
            </SiteLink>
          );
        })}
      </div>
    </>
  ) : null;
};

export default BundleVariations;
